import React from "react";
import { Link } from "react-router-dom";
import parse from "html-react-parser";
import { useDataContext } from "../../../../data/providers/DataProvider";
import { formatNumber } from "../../../../utils/AssetHelpers";
import { getBadgeColorByStatus, getStatus } from "../../../../utils/shared";
import Slider from "react-slick";

/**
 * 
 * @param {*} apartment
 */
export const getApartmentsSliderItem = (apartment) => {

    const publicUrl = process.env.PUBLIC_URL + "/";

    return (
        <div className="ltn__product-item ltn__product-item-4 text-center---">
            <div className="product-img go-top">
                <Link to={`/appartements/${apartment.id}`}>
                    <img
                        src={`${publicUrl}assets/img/apartments/${apartment.id}/${apartment.real_estate.images[0].file_name}`}
                        // src={`${publicUrl}assets/img/apartments/1/${apartment.real_estate.images[0].file_name}`}
                        alt="Illustration"
                    />
                </Link>
                <div className="product-badge">
                    <ul>
                        <li className={`sale-badge ${getBadgeColorByStatus(apartment.real_estate)}`}>{getStatus(apartment.real_estate)}</li>
                    </ul>
                </div>
                <div className="product-img-location-gallery px-3">
                    <div className="product-img-location">
                        <p
                            className="m-0 text-white text-truncate cursor-default"
                            title={`${apartment.real_estate.municipality.name}, ${apartment.real_estate.street}`}
                        >
                        <small>
                            <i className="flaticon-pin" />{" "}
                            {`${apartment.real_estate.municipality.name}, ${apartment.real_estate.street}`}
                        </small>
                        </p>
                    </div>
                {
                    apartment.real_estate.belongs_to_alphaimmo &&
                    <div className="real-estate-agent">
                        <div className="agent-img bg-white rounded-circle p-1 m-0">
                            <a href="/terganeteranga">
                                <img
                                    src={`${publicUrl}assets/img/icons/mascotte-terganeteranga.png`}
                                    alt="Mascotte TerganeTeranga"
                                    width={32}
                                    title="TerganeTeranga"
                                />
                            </a>
                        </div>
                    </div>
                }
                    {/* <div className="product-img-gallery go-top">
                        <ul>
                            <li>
                                <Link to={`/appartements/${apartment.id}`}>
                                    <i className="fas fa-camera" />{" "}
                                    4
                                </Link>
                            </li>
                            <li>
                                <Link to={`/appartements/${apartment.id}`}>
                                    <i className="fas fa-film" />{" "}
                                    2
                                </Link>
                            </li>
                        </ul>
                    </div> */}
                </div>
            </div>
            <div className="product-info">
                <div className="product-price fs-6">
                    <small>
                        <span>
                            {formatNumber(apartment.real_estate.price)}{" "}<label>FCFA</label>
                        {
                            apartment.real_estate.status === "RENT" && 
                            <label>/Mois</label>
                        }
                        </span>
                    {
                        apartment.real_estate.monthly_price &&
                        <span>{" - "}{formatNumber(apartment.real_estate.monthly_price)} <label>FCFA</label> <label>/ Mois</label></span>
                    }
                    </small>
                </div>
                <h3 className="product-title go-top fs-6">
                    <Link to={`/appartements/${apartment.id}`}>Appartement</Link>
                </h3>
                <div className="product-description">
                    <p className="clamped-text clamped-text-1">{apartment.real_estate.description}</p>
                </div>
                <ul className="ltn__list-item-2 ltn__list-item-2-before personalized row">
                    <li className="d-inline-flex align-items-center gap-1 col-6 m-0 py-1">
                        <span>Supercifie:</span>
                        <span>{parseInt(apartment.real_estate.superficies)} m<sup>2</sup></span>
                    </li>
                    <li className="d-inline-flex align-items-center gap-1 col-6 m-0 py-1">
                        <span>Chambres:</span>
                        <span>{apartment.rooms_number}</span>
                    </li>
                    <li className="d-inline-flex align-items-center gap-1 col-6 m-0 py-1">
                        <span>Salles de bain:</span>
                        <span>{apartment.bathrooms_number}</span>
                    </li>
                    <li className="d-inline-flex align-items-center gap-1 col-6 m-0 py-1">
                        <span>Toilettes:</span>
                        <span>{apartment.toilets_number}</span>
                    </li>
                    <li className="d-inline-flex align-items-center gap-1 col-6 m-0 py-1">
                        <span>Niveau:</span>
                        <span>{apartment.level} étage</span>
                    </li>
                    <li className="d-inline-flex align-items-center gap-1 col-6 m-0 py-1">
                        <label>Position du bâtiment:</label>{" "}
                        <span>{apartment.house_position === 'CORNER' ? "Angle" : "Simple"}</span>
                    </li>
                </ul>
            </div>
        </div>
    );
};

/**
 * 
 * @returns 
 */
const ApartmentsSlider = () => {

    const { apartments } = useDataContext();

    return (
        <div
            id="homeApartmentsSliderSection"
            className="home-real-estates-slider-subsection"
        >
            <div className="ltn__product-slider-area ltn__product-gutter">
                <div className="container-fluid container-lg">
                {
                    apartments.length > 0
                    ?
                    <Slider
                        arrows={apartments.length > 3}
                        dots={true}
                        infinite={apartments.length > 3}
                        speed={300}
                        slidesToShow={3}
                        slidesToScroll={1}
                        prevArrow={<button type="button" className="slick-prev"><i className="fas fa-arrow-left" alt="Arrow Icon"></i></button>}
                        nextArrow={<button type="button" className="slick-next"><i className="fas fa-arrow-right" alt="Arrow Icon"></i></button>}
                        responsive={[
                            {
                                breakpoint: 992,
                                settings: {
                                    arrows: false,
                                    dots: true,
                                    slidesToShow: 2,
                                    slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 768,
                                settings: {
                                    arrows: false,
                                    dots: true,
                                    slidesToShow: 2,
                                    slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 580,
                                settings: {
                                    arrows: false,
                                    dots: true,
                                    slidesToShow: 2,
                                    slidesToScroll: 1
                                }
                            },
                            {
                                breakpoint: 480,
                                settings: {
                                    arrows: false,
                                    dots: true,
                                    slidesToShow: 1,
                                    slidesToScroll: 1
                                }
                            }
                        ]}
                        className="row ltn__product-slider-item-four-active slick-arrow-1"
                    >
                    {
                        apartments.slice(0, 6).map((apartment, index) => {
                            return (
                                // {/* ltn__product-item */}
                                <div key={index} className="col-12">
                                {
                                    getApartmentsSliderItem(apartment)
                                }
                                </div>
                                // {/* ltn__product-item */}
                            );
                        })
                    }
                    </Slider>
                    :
                    <div className="d-flex align-items-center justify-content-center py-5">
                        <div className="w-100 d-flex align-items-center justify-content-center alert alert-primary">
                            <p className="m-0">Aucun appartement disponible pour le moment</p>
                        </div>
                    </div>
                }
                </div>
                {
                    apartments.length > 0 &&
                    <div className="btn-wrapper text-center go-top">
                        <Link to="/appartements" className="btn theme-btn-1 btn-effect-1 text-uppercase">Voir tout</Link>
                    </div>
                }
            </div>
        </div>
    );
};

export default ApartmentsSlider;
